import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	letter-spacing: 0.3px;
	height: fit-content;
`;

export const List = styled.div``;

export const Title = styled.span`
	display: inline-block;
	height: 39px;
	line-height: 36px;
	font-weight: 500;
	font-size: 16px;
	margin-top: 4px;

	padding: 0 24px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Value = styled.span`
	display: inline-block;
	height: 21px;
	line-height: 16px;
	font-weight: 400;
	font-size: 13px;
`;

export const Header = styled.div`
	margin-top: 8px;
	display: flex;
	margin-bottom: 8px;
`;

export const HeaderLabel = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 100%;
`;

export const ColName = styled.div`
	flex: 1;
	margin-right: auto;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const ColValue = styled.div`
	text-align: right;
	${({ colsPerRow }) =>
		colsPerRow === 1
			? css`
					width: 55px;
			  `
			: `
				width: 42px;
			`};

	width: 55px;
	margin-right: 8px;
	margin-left: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const TotalColValue = styled(ColValue)`
	color: ${colors.grey5};

	font-size: 13px;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
`;

export const OthersColValue = styled(ColValue)`
	color: ${colors.grey5};

	font-size: 13px;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
`;

export const ContextualMenuBtnWrapper = styled.div`
	position: absolute;
	left: -26px;
	top: -9px;

	${({ open }) => (open ? 'display: block;' : 'display: none;')};
`;

export const Row = styled.div`
	display: flex;
	color: #1a1a1a;
	font-size: 13px;
	line-height: 19px;
	font-weight: 400;
	box-shadow: inset 0px -1px 0px #d8d8d8;
	padding: 2px 0px 3px 8px;
	position: relative;

	${ColValue} {
		justify-content: right;
	}

	&:hover ${ContextualMenuBtnWrapper} {
		display: block;
	}
`;

export const Box = styled.div`
	height: 68px;
	background: ${colors.grey2};
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;

	${({ isTopItem }) =>
		isTopItem
			? css`
					${Title} {
						font-size: 19px;
					}
					background-color: #cdd5da;
					height: 72px;
			  `
			: ''};
`;
